import { set, lensProp } from 'ramda';

import {
  HANDLE_SERVICES_LINK_LOADING,
  SET_SERVICES_LINK_ERRORS,
  CLEAR_SERVICES_LINK_ERRORS
} from './constants';

const defaultState = {
  isLoading: false,
  errors: {
    servicesLink: null
  },
  submit: {
    servicesLink: [],
    loadingServicesLink: ''
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case HANDLE_SERVICES_LINK_LOADING: {
      return set(lensProp('isLoading'), action.status, state);
    }
    case SET_SERVICES_LINK_ERRORS: {
      return {
        ...state,
        errors: {
          servicesLink: action.errors?.servicesLink ? action.errors?.servicesLink[0] : null
        }
      }
    }
    case CLEAR_SERVICES_LINK_ERRORS: {
      return set(lensProp('errors'), {}, state);
    }
    default: {
      return state;
    }
  }
}